import { RouterLink } from '../../../components/AcademyLinks';
import { WIZARD_URL_FRAGMENT } from '../../../constants/Navigation';
import UsageTracker from '../../../utils/UsageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import RecommendationsResetModal from '../../../components/Recommendations/RecommendationsResetModal';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { RankedRecommendationsWithNegativeFeedback } from './RankedRecommendationsWithNegativeFeedback';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RankedRecommendationsDescription = () => {
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const handleUpdateRecommendationsLinkClick = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'ranked-recommendations-reset-click'
    });
  };
  const handleUpdateRecommendationsInfoClick = () => {
    setIsResetModalOpen(true);
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'ranked-recommendations-info-click'
    });
  };
  const handleResetModalClose = () => {
    setIsResetModalOpen(false);
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'ranked-recommendations-info-closed'
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.tracks.subheaders.personalRecommendations"
    }), /*#__PURE__*/_jsx(RouterLink, {
      marginInlineStart: "100" /* TODO double check if this is working as intended */,
      onClick: handleUpdateRecommendationsLinkClick,
      to: WIZARD_URL_FRAGMENT,
      underline: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.resetLink.linkMessage"
      })
    }), /*#__PURE__*/_jsx(IconButton, {
      marginInlineStart: "-200",
      onClick: handleUpdateRecommendationsInfoClick,
      padding: "0",
      use: "transparent",
      children: /*#__PURE__*/_jsx(InfoIcon, {
        color: "icon-core-subtle",
        size: "200"
      })
    }), isResetModalOpen && /*#__PURE__*/_jsx(RecommendationsResetModal, {
      onClose: handleResetModalClose
    })]
  });
};
export const RankedRecommendations = ({
  containerError,
  containerLoading,
  cardSize = 'extra-large',
  onRenderEmpty
}) => {
  const {
    isTablet
  } = useMediaQuery();
  const handleOnItemClick = (item, index) => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'catalog-recommendation-card-click',
      cardNumber: index + 1,
      contentId: item.id,
      contentType: item.type,
      name: item.name,
      language: item.language,
      recommendationType: 'ranked'
      //recommendationStrategy: 'TODO', --> weed to decide the strategy serialisation from the explanations response schema with the BE team
    });
  };
  return /*#__PURE__*/_jsx(RankedRecommendationsWithNegativeFeedback, {
    appearsIn: "ranked-recommendations",
    cardsContainerProps: {
      paddingBlockEnd: '0'
    },
    containerError: containerError,
    containerLoading: containerLoading,
    description: /*#__PURE__*/_jsx(RankedRecommendationsDescription, {}),
    direction: isTablet ? 'column' : 'row',
    errorMarker: "HOMEPAGE_RECOMMENDATIONS_ERROR",
    flush: true,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.tracks.headers.recommended"
    }),
    inferenceSource: "ACADEMY_HOME",
    navMarker: "HOMEPAGE_RECOMMENDATIONS_LOADED",
    onItemClick: handleOnItemClick,
    onRenderEmpty: onRenderEmpty,
    size: isTablet ? 'small' : cardSize
  });
};